module.exports = __webpack_public_path__ + "static/media/PDF_74.fc924eb1.pdf";